

<form [formGroup]="contactForm" >

  <div class="pageHeader" id="Contact Info">
    <span>Contact Info</span>
  </div>

  <div class="confirmation-msg" *ngIf="confirmFlag">
    Your contact Information has been saved. Please hit the "CONTINUE" button to proceed.
  </div>


  <div>
    <div class="errorMessage " *ngIf="errorMessage.length">
      {{errHeading}}
      <li *ngFor="let message of errorMessage">{{message}}</li>
      <hr class="hrStyle">
    </div>
  </div>

<div class="ui-g container grid-conatiner">

  <div class="ui-g-12">
    <div class="ui-g-2 label-font">Seller Number:</div>
    <div class="ui-g-2">

      <fm-select *ngIf="!confirmFlag"
        [options]="selNumber" formControlName="sellerNumber"
        ariaLabelledBy="default"
      ></fm-select>

      <span *ngIf="confirmFlag"> {{contactForm.get('sellerNumber').value}} </span>

    </div>
    <div class="ui-g-8"></div>
  </div>


  <div class="ui-g-12 strip-color">
    <div class="ui-g-2 label-font">Contact Name:</div>
    <div class="ui-g-2"><input *ngIf="!confirmFlag" type="text" fmTextInput formControlName="sellerContactName" >
      <span *ngIf="confirmFlag"> {{contactForm.get('sellerContactName').value}} </span>
    </div>
    <div class="ui-g-2 label-font">Contact Phone #:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="sellerContactNumber" >
      <span *ngIf="confirmFlag"> {{contactForm.get('sellerContactNumber').value}} </span>
    </div>
    <div class="ui-g-2 label-font"> Contact Fax #:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="sellerContactFax" >
      <span *ngIf="confirmFlag"> {{contactForm.get('sellerContactFax').value}} </span>
    </div>
  </div>

  <div class="ui-g-12">
    <div class="ui-g-2 label-font">Servicer Number:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="servicerNumber" >
      <span *ngIf="confirmFlag"> {{contactForm.get('servicerNumber').value}} </span>
    </div>
    <div class="ui-g-8"></div>
  </div>

  <div class="ui-g-12 strip-color">
    <div class="ui-g-2 label-font">Contact Name:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="servicerContactName" >
      <span *ngIf="confirmFlag"> {{contactForm.get('servicerContactName').value}} </span>
    </div>
    <div class="ui-g-2 label-font">Contact Phone #:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="servicerContactNumber" >
      <span *ngIf="confirmFlag"> {{contactForm.get('servicerContactNumber').value}} </span>
    </div>
    <div class="ui-g-2 label-font"> Contact Fax #:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="servicerContactFax" >
      <span *ngIf="confirmFlag"> {{contactForm.get('servicerContactFax').value}} </span>
    </div>
  </div>

  <div class="ui-g-12">
    <div class="ui-g-2 label-font">Subservicer Number:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag"  fmTextInput formControlName="subServicerNumber" >
      <span *ngIf="confirmFlag"> {{contactForm.get('subServicerNumber').value}} </span>
    </div>
    <div class="ui-g-8"></div>
  </div>

  <div class="ui-g-12 strip-color">
    <div class="ui-g-2 label-font">Contact Name:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="subServicerContactName" >
      <span *ngIf="confirmFlag"> {{contactForm.get('subServicerContactName').value}} </span>
    </div>
    <div class="ui-g-2 label-font">Contact Phone #:</div>
    <div class="ui-g-2">
      <input type="text" *ngIf="!confirmFlag" fmTextInput formControlName="subServicerContactNumber" >
      <span *ngIf="confirmFlag"> {{contactForm.get('subServicerContactNumber').value}} </span>
    </div>
    <div class="ui-g-2 label-font"> Contact Fax #:</div>
    <div class="ui-g-2">
      <input *ngIf="!confirmFlag" type="text" fmTextInput formControlName="subServicerContactFax" >
      <span *ngIf="confirmFlag"> {{contactForm.get('subServicerContactFax').value}} </span>
    </div>
  </div>


</div>


<div class="ui-g contact-op-buttons">
  <div class="ui-g-6">
    <button *ngIf="!confirmFlag" fmButton type="button" (click)="saveContact()" [small]="true" [primary]="true"
      label="Save" class="dispbuttonMargin"></button>
    <button *ngIf="!confirmFlag" fmButton type="button" [small]="true" [primary]="true" label="Clear" (click)="clear()"
      class="dispbuttonMargin"></button>
    <button *ngIf="!confirmFlag && cancelDisplay" fmButton type="button" [small]="true" [primary]="true" label="Cancel"
      routerLink="/reverseMortgage" class="dispbuttonMargin"></button>
    <button *ngIf="confirmFlag" fmButton type="button" (click)="saveConfirm()" [small]="true" [primary]="true"
      label="Continue" class="dispbuttonMargin"></button>
  </div>
</div>
</form>
